<template>
  <div class="relative">
    <div v-if="isLoading" class="absolute inset-0 z-10 bg-white rounded-xl">
      <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
        <svg class="h-26 w-16 animate-spin text-blue-600 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
          <path d="M12 2 A 10 10 0 0 1 22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
        </svg>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
      <div
        v-for="card in mainCards"
        :key="card.title"
        class="bg-white border border-gray-200 rounded-2xl p-6"
      >
        <img :src="card.icon" class="w-8 h-8 mb-4" alt="" />
        <p class="text-base text-gray-500 mb-1">{{ card.title }}</p>
        <h3 class="text-2xl font-bold text-gray-900 mb-0">{{ card.value }}</h3>
      </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div
        v-for="(group, index) in metricGroups"
        :key="index"
        class="relative overflow-hidden bg-white border border-gray-200 rounded-2xl p-6"
      >
        <div class="relative grid grid-cols-3 gap-4">
          <div v-for="metric in group" :key="metric.title">
            <div class="flex items-center justify-center w-8 h-8 mb-4 rounded-lg bg-gray-100 text-gray-700">
              <i :class="metric.icon"></i>
            </div>
            <p class="text-base text-gray-500 mb-1">{{ metric.title }}</p>
            <h3 class="text-2xl font-bold text-gray-900 mb-0">{{ formatNumber(metric.value) }}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qrcodeIcon from '@/assets/img/qrcode.png';
import purchaseIcon from '@/assets/img/purchase.png';
import subscribeIcon from '@/assets/img/subcribe.png';

export default {
  name: 'LocationSummaryCards',
  props: {
    summary: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mainCards() {
      return [
        { title: 'Total Scan', icon: qrcodeIcon, value: this.formatNumber(this.summary.totalScan) },
        { title: 'Purchase After Scan', icon: purchaseIcon, value: this.summary.purchaseAfterScan || 'Rp0' },
        { title: 'Subscribe After Scan', icon: subscribeIcon, value: this.summary.subscribeAfterScan || 'Rp0' },
      ];
    },
    metricGroups() {
      return [
        [
          { title: 'Camera to Install', icon: 'fa-solid fa-download', value: this.summary.cameraToInstall },
          { title: 'Camera to Apps', icon: 'fa-solid fa-camera', value: this.summary.cameraToApps },
          { title: 'Camera to Onsite', icon: 'fa-solid fa-mobile-screen-button', value: this.summary.cameraToOnsite },
        ],
        [
          { title: 'Total Visitor', icon: 'fa-solid fa-user-group', value: this.summary.totalVisitor },
          { title: 'Total Registration', icon: 'fa-solid fa-pen-to-square', value: this.summary.totalRegistration },
          { title: 'Total Reader', icon: 'fa-solid fa-book', value: this.summary.totalReader },
        ],
      ];
    },
  },
  methods: {
    formatNumber(value) {
      return Number(value || 0).toLocaleString('id-ID');
    },
  },
};
</script>
